import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../shared/modals/modal.component';

class RefusedDeletingModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    isVisible: PropTypes.bool,
  };

  render() {
    const { hideModal, message, isVisible } = this.props;

    return (
      <Modal
        className="add-tag-modal"
        dismissText="Ok"
        closeAction={hideModal}
        dismissAction={hideModal}
        isVisible={isVisible}
      >
        <div>
          {message}
        </div>
      </Modal>
    );
  }
}

export default RefusedDeletingModal;
